import React, { Fragment, useRef, useState, useEffect } from 'react'
import PopUp from '../Common/PopUp';
import Filter from '../Common/Filter';
import Table from '../Common/Table';
import { showToast } from '../Common/Messages';
import { useSelector } from 'react-redux';
import { dateFormat } from '../libs/Util';

export function usePrevState(state) {
    const ref = useRef(state);
    useEffect(() => {
        ref.current = state;
    }, [state]);
    return ref.current;
}

const AdminManagement = () => {
    const [veiwList, setVeiwList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [listTitle, setListTitle] = useState('');
    const [popupContent, setPopupContent] = useState(null);
    // const authGradeList = ["", "TF", "Install", "Staff", "Manager", "Director"];
    const [authGradeList, setAuthGradeList] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState("");
    let selectedAuthGrade = '', selectedRecvMail = '0';

    useEffect(() => {
        getAuthGradeList();
    }, []);

    useEffect(() => {
        if (userList.length === 0) {
            fetch('api/User/GetYlwUserInfo', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then((response) => response.json())
                .then((data) => {
                    setUserList(data.table);
                });
        }
    }, [userList]);

    useEffect(() => {
        if (selectedGroup !== "" && userList.length > 0) {
            const filteredUsers = getFilteredUserList(true);
            setVeiwList(filteredUsers);
            setFilteredUsers(filteredUsers);
        } else {
            setVeiwList(userList);
            setFilteredUsers(userList);
        }
    }, [selectedGroup, userList]);

    useEffect(() => {
        const groupName = selectedGroup || '전체';
        setListTitle(filteredUsers.length > 0 ? `${groupName} (${filteredUsers.length}명)` : groupName);
    }, [filteredUsers]);

    const getAuthGradeList = () => {
        fetch('/datas/oper/admin_grade.json')
        .then((response) => response.json())
        .then((data) => {
            setAuthGradeList(data.admin);
        });
    }

    const handleSelectGroup = (group) => {
        setSelectedGroup(group)
    };

    const handleChange = (e) => {
        if (e.target.id === 'authGrade') {
            selectedAuthGrade = (e.target.value === '없음' ? '' : e.target.value);
        } else if (e.target.id === 'recvMail') {
            selectedRecvMail = e.target.value;
        }
    }

    const getSendOtpName = (value) => {
        let Text = '사용안함';
        if (value === 1) {
            Text = '메일';
        }
        if (value === 2) {
            Text = '카카오톡';
        }
        return Text;
    }
    const btnOnPopup = (e, item, index) => {
        setPopupContent(item !== null && item !== undefined
            ? renderMoreMenu(item, index) : null);
    }

    const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleMouseDown = (event) => {
        setPosition({ x: event.clientX, y: event.clientY });
    };

    const renderMoreMenu = (item, index) => {
        return (
            <div className="layer-list admin-more-menu" style={{ top: position.y + 'px', left: position.x + 'px' }}>
                <div className="box">
                    <ul>
                        <li><a onClick={e => renderSelectedUserInfo(item, index)}>사용자 정보</a></li>
                        <li><a onClick={e => setTempPassword(item)}>임시비밀번호 발급</a></li>
                        <li><a onClick={e => resetLoginFailCnt(item, index)}>로그인 실패횟수 초기화</a></li>
                    </ul>
                </div>
            </div>
        );
    }

    const renderSelectedUserInfo = (item, index) => {
        let pwdChgDate = '';

        if (item !== null && item !== undefined && item.pwdChgDate !== null && item.pwdChgDate !== undefined) {
            if (item.pwdChgDate.trim() !== '') {
                pwdChgDate = item.pwdChgDate.substr(0, 4) + '.' + item.pwdChgDate.substr(4, 2) + '.' + item.pwdChgDate.substr(6, 2);
            }
        }
        setPopupContent(item !== null && item !== undefined
            ? <div className="msg-popup admin-user-info">
                <div className="box w-480">
                    <div className="title-wrap">
                        <p className="modal-title">사용자 정보</p>
                        <button className="btn-close" onClick={e => btnOnPopup(e, null, null)}><i className="icoKdc32 close"></i></button>
                    </div>
                    <form className="form-wrap">
                        <div className="user-info-list">
                            <dl className="" id="kindText">
                                <dt>이름</dt>
                                <dd>{item.devUserName}</dd>
                            </dl>
                            <dl className="" id="">
                                <dt>이메일 아이디</dt>
                                <dd>{item.devUserID}</dd>
                            </dl>
                            <dl className="" id="">
                                <dt>소속</dt>
                                <dd>{item.getCompanyName}</dd>
                            </dl>
                            {item.deptName !== null && item.deptName !== '' ?
                                <dl className="">
                                    <dt>부서</dt>
                                    <dd>{item.deptName}</dd>
                                </dl> : null}
                            {item.getKindName !== null && item.getKindName !== '' ?
                                <dl className="">
                                    <dt>직무</dt>
                                    <dd>{item.getKindName}</dd>
                                </dl> : null}

                            <dl className="" id="">
                                <dt>2차인증</dt>
                                <dd>{getSendOtpName(item.sendOtpType)}</dd>
                            </dl>

                            <dl>
                                <dt>관리자 권한</dt>
                                <dd>
                                    <select id="authGrade" defaultValue={item.authGrade ?? ''} onChange={e => handleChange(e)}>
                                        {authGradeList.map((item, i) => (
                                            <option value={item} key={"authGrade" + i}>
                                                {item === '' ? '없음' : item}
                                            </option>
                                        ))}
                                    </select>
                                </dd>
                            </dl>

                            <dl>
                                <dt>관리자 메일</dt>
                                <dd>
                                    <select id="recvMail" defaultValue={item.recvMail ?? '0'} onChange={e => handleChange(e)}>
                                        <option value="1" key="recvMail1">수신함</option>
                                        <option value="0" key="recvMail2">수신안함</option>
                                    </select>
                                </dd>
                            </dl>

                            <dl className="" id="">
                                <dt>비밀번호 변경일</dt>
                                <dd>{pwdChgDate}</dd>
                            </dl>
                            <dl className="" id="">
                                <dt>로그인 실패횟수</dt>
                                <dd>{item.loginFailCnt !== null ? item.loginFailCnt + "회" : "0회"}</dd>
                            </dl>
                            <dl className="" id="">
                                <dt>마지막 로그인</dt>
                                <dd>{item.lastLoginDateTime !== null ? dateFormat(new Date(item.lastLoginDateTime)) : '미접속'}</dd>
                            </dl>

                        </div>
                    </form>
                    <div className="btn-wrap">
                        <button className="btn-primary" onClick={e => saveDevelopersCenterAdmin(item, index)}>업데이트</button>
                    </div>
                </div>
            </div> : null);
    }
    const setTempPassword = (item) => {
        if (window.confirm(item.devUserID + '에 대한 임시비밀번호 발급을 진행합니다. 계속하시겠습니까?')) {
            const userNameId = {
                userName: item.devUserName,
                userId: encodeURI(item.devUserID)
            };

            fetch('api/Login/FindPassword', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(userNameId)
            }).then(async (response) => response.json())
                .then((responseData) => {
                    if (responseData.status === "Success Finding") {
                        showToast('success', '임시 비밀번호 발급에 성공하였습니다.', 3000);
                        setPopupContent(null);
                    }
                    else if (responseData.status === "Fail Sending") {
                        showToast('danger', responseData.message, 3000);
                    }
                });
        }
    }
    const resetLoginFailCnt = (item, index) => {
        if (window.confirm(item.devUserID + '에 대한 로그인 실패횟수 초기화를 진행합니다. 계속하시겠습니까?')) {
            fetch('api/User/ResetLoginFailCnt?userId=' + item.devUserID, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then(async (response) => response.json())
                .then((responseData) => {
                    if (responseData.table[0].status === 'true') {
                        showToast('success', '초기화에 성공하였습니다.', 3000);
                        let newUserList = filteredUsers;
                        newUserList[index].loginFailCnt = 0;
                        setFilteredUsers(newUserList);
                        setPopupContent(null);
                    }
                    else {
                        showToast('danger', responseData.message, 3000);
                    }
                });
        }
    }
    const saveDevelopersCenterAdmin = (item, index) => {
        fetch('api/User/SaveDevelopersCenterAdmin?userId=' + item.devUserID + '&authGrade=' + selectedAuthGrade + '&recvMail=' + selectedRecvMail, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then(async (response) => response.json())
            .then((responseData) => {
                if (responseData.table[0].status === 'true') {
                    showToast('success', '저장이 완료되었습니다.', 3000);
                    let newUserList = filteredUsers;
                    newUserList[index].authGrade = selectedAuthGrade;
                    newUserList[index].recvMail = selectedRecvMail;
                    setFilteredUsers(newUserList);
                    setPopupContent(null);
                }
                else {
                    showToast('danger', responseData.message, 3000);
                }
            });
    }
    const renderUserList = () => {
        let list = [];
        for (let i = 0; i < filteredUsers.length; i++) {
            list.push(
                <tr key={i}>
                    <td></td>
                    <td>{filteredUsers[i].devUserName}</td>
                    <td>{filteredUsers[i].devUserID}</td>
                    <td>{filteredUsers[i].deptName}</td>
                    <td>{filteredUsers[i].getCompanyName}</td>
                    <td>{filteredUsers[i].authGrade ?? '없음'}</td>
                    <td><button className="btn-admin-more" onClick={e => btnOnPopup(e, filteredUsers[i], i)}><i className="i-btn-more"></i></button></td>
                </tr>
            );
        }
        return list;
    }
    const list = renderUserList();
    const setHeaders = () => {
        return [
            "",
            "이름",
            "이메일 아이디",
            "부서",
            "소속",
            "관리자권한",
            ""
        ];
    };

    const getFilteredUserList = (isMatch = true) => {
        return userList.filter(user =>
            isMatch
                ? user.authGrade === selectedGroup || (selectedGroup === "" && user.authGrade === null) || (selectedGroup === "" && user.authGrade === ''
                )
                : !user.authGrade || user.authGrade === '' || user.authGrade === null
        );
    };

    return (
        <div className="content-scroll">
            <div className="content" onMouseDown={handleMouseDown} >
                <div className="content-left">
                    <div className="list-top">
                        <h3 className='list-title'>관리자 권한 그룹</h3>
                    </div>
                    <ul className='group-list'>
                        <li className={`group-item ${selectedGroup === "" ? 'selected' : ''}`} key="" onClick={() => handleSelectGroup("")}>
                            <div className="group-name-wrap">
                                <i className="icoKdc20 user"></i>
                                <p className="group-name">전체</p>
                            </div>
                        </li>
                        {authGradeList.filter(Boolean).map((grade, index) => (
                            <li className={`group-item ${selectedGroup === grade ? 'selected' : ''}`} key={grade} onClick={() => handleSelectGroup(grade)}>
                                <div className="group-name-wrap">
                                    <i className='icoKdc20 user'></i>
                                    <p className='group-name'>{grade}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="content-right">
                    <h3 className='list-title mb-12'>{listTitle}</h3>
                    <div className="list-tools">
                        <Filter key={0}
                            listData={veiwList}
                            setListView={setFilteredUsers}
                            multiKeywords={[{ name: "getCompanyName", title: "소속" }]}
                            searchKeyword={{ name: ["devUserID", "devUserName"], title: "이름 또는 아이디로 검색" }}
                        />
                    </div>
                    <Table className={"userlist"} headers={setHeaders()} list={list} />
                    <PopUp setContent={() => btnOnPopup()} content={popupContent} />
                </div>
            </div>
        </div>
    );
}

export default AdminManagement;